import { getAuthToken, setAuthToken } from "components/common/authTokenManager";
import { onGlobalError } from "../services/serviceHelper";
const { REACT_APP_V2_API_ENDPOINT } = process.env;

// 401s from these routes should NOT trigger the delegate modal
const DELEGATE_401_BLACKLIST = [
  "/users/current",
  "/offices/restore-delegate",
  "/auth/logout",
  "/chats/unread",
  // add more routes here as needed
];

export async function v2Request(route, fetchConfig = {}) {
  const token = getAuthToken();

  const baseConfig = {
    method: "GET",
    credentials: "include",
    mode: "cors",
    headers: { "Content-Type": "application/json", "X-Token": token || "" },
    ...fetchConfig,
  };

  const doFetch = async () => {
    const res = await fetch(REACT_APP_V2_API_ENDPOINT + route, baseConfig);

    const isBlacklisted = DELEGATE_401_BLACKLIST.some((p) =>
      route.startsWith(p),
    );

    const data = await res.json().catch(() => ({}));

    // Signed out server-side (logged out elsewhere, rep signed in on another
    // device, or an admin ended the session). The token is gone for good, so
    // go straight to login — the delegate "restore" modal can't help here.
    // `/users/current` is exempt: every page load calls it and already treats
    // a failure as "not logged in", including on public pages.
    if (
      res.status === 401 &&
      data?.reason === "SESSION_REVOKED" &&
      !route.startsWith("/users/current")
    ) {
      setAuthToken(null);
      window.location.replace("/login");
      return data;
    }

    // Only fire the modal event for non‑blacklisted routes
    if (res.status === 401 && !isBlacklisted) {
      console.log(
        "401 detected on",
        route,
        "-> dispatching delegate-auth-lost",
      );
      window.dispatchEvent(new CustomEvent("delegate-auth-lost"));
    }

    return data;
  };

  try {
    return await doFetch();
  } catch (err) {
    return onGlobalError(err);
  }
}
